/* eslint-disable @typescript-eslint/no-explicit-any */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InlineRadioField } from "@cinch-labs/design-system";
const FindACarRadioField = ({ classNames , input , label ="" , helpText , options =[] , onBlur , onFocus , onChange , sharedSubLabelText , sharedSubLabelClass  })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(InlineRadioField, {
                ...input,
                value: input.value,
                helpText: helpText,
                onBlur: (e)=>{
                    input.onBlur(e);
                    if (onBlur) onBlur(e);
                },
                onFocus: (e)=>{
                    input.onFocus(e);
                    if (onFocus) onFocus(e);
                },
                onChange: (e)=>{
                    input.onChange(e);
                    if (onChange) onChange(e);
                },
                label: label,
                options: options.map((option, index)=>{
                    option.id = `${input.name}-${index}`;
                    return option;
                }),
                classNames: classNames
            }),
            !!sharedSubLabelText && /*#__PURE__*/ _jsx("p", {
                className: sharedSubLabelClass,
                children: sharedSubLabelText
            })
        ]
    });
export default FindACarRadioField;
